
import HeroSection from "./components/HeroSection";
import ServicesOverview from "./components/ServicesOverview";
import ManufacturingCapabilities from "./components/ManufacturingCapabilities";
import QualityAssurance from "./components/QualityAssurance";
import GlobalSupport from "./components/GlobalSupport";

export default function Services() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <ServicesOverview />
      <ManufacturingCapabilities />
      <QualityAssurance />
      <GlobalSupport />
    </div>
  );
}
